import {
	CancelOrder,
	CancelOrderByAdmin,
	CancelOrderByAdminNoRefund,
} from "../../../../services/OrderService";
import User, { UserRole } from "../../../../models/User";
import useAlertDialog from "../../../hooks/useAlertDialog";
import { AlertType } from "../../../hooks/common/useAttachAlertDialog";

export default function useCancelOrder(props: {
	reload: () => void;
	user?: User | null;
	setLoad: (val: boolean) => void;
}) {
	const { openAlertDialog } = useAlertDialog();
	const doCancelOrder = async (id: number) => {
		props.setLoad(true);
		try {
			props?.user?.role === UserRole.Admin ? await CancelOrderByAdmin(id) : await CancelOrder(id);
			props.setLoad(false);
			openAlertDialog?.(AlertType.Success, "Cancel successfully!", () => {
				props.reload();
			});
		} catch (err: any) {
			console.error(err);
			props.setLoad(false);
			openAlertDialog?.(AlertType.Fail, err?.response.data?.message || "Cancel Fail!");
		}
	};

	const doCancelOrderNoRefund = async (id: number) => {
		props.setLoad(true);
		try {
			await CancelOrderByAdminNoRefund(id);
			props.setLoad(false);
			openAlertDialog?.(AlertType.Success, "Cancel successfully!", () => {
				props.reload();
			});
		} catch (err: any) {
			console.error(err);
			props.setLoad(false);
			openAlertDialog?.(AlertType.Fail, err?.response?.data?.message || "Cancel Fail!");
		}
	};

	return {
		doCancelOrder,
		doCancelOrderNoRefund,
	};
}
